import { Component, Input, OnInit } from '@angular/core';
import { ColumnChartConfig } from '../../../../../shared/google-chart/Models/ColumnChartConfig';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import * as moment from 'moment';

@Component({
  selector: 'app-plink-utilization',
  templateUrl: './plink-utilization.component.html',
  styleUrls: ['./plink-utilization.component.css']
})
export class PlinkUtilizationComponent implements OnInit {
  @Input() data: any;
  @Input() siteId: number = 0;
  @Input() customerId: number = 0;
  @Input() siteBattviewsData: any = {};
  @Input() siteTags: any = {};
  @Input() siteBattviewsTags: any = {};
  @Input() customerName: string = '';
  @Input() siteName: string = '';

  config: ColumnChartConfig;
  filteredData: any;
  tableColumns: any[] = [
    {title: "PolarLink ID", property: "id"},
    {title: "PolarLink SN", property: "serialNumber"},
    {title: "Value", property: "value"}
  ];
  title: string = 'Utilization';
  tooltipText: string = 'The percentage of polarlinks being utilized by plug ins is displayed.';
  elementId: string = 'plinks-utilization';
  widgetClass: string = 'auto-height-widget';
  siteWidgetOptions: any = {
    hasOperation: false,
    hasChargerModels: false,
    hasNormalizeCheckBox: false,
    hasDate: true,
    isSitePerformanceWidget: true,
    isChargers: false,
    isPlink: true,
    excludeSinceInstallationOption: true,
    hideYesterdayDate: true,
    isCircleWidget: true
  };

  constructor(private commonUtil: CommonUtil){};

  ngOnInit() {
		this.initializeConfig();

		// Initialize filteredData and chartData if needed
		if (!this.filteredData && this.data) {
			this.filteredData = {
				list: this.data || []
			};
		}
	}

  private initializeConfig() {
		this.config = new ColumnChartConfig({
			isPercent: true,
			xTitle: "% Utilization",
			yTitle: "% PolarLinks",
			widgetHeight: 400,
			chartArea: {top: 10, width:'70%', height:'80%'},
			vAxisMinValue: 0,
			tooltip: {trigger: 'hover'}
		});

		this.config.formatFunction = (data: any) => {

			if(Array.isArray(data) && data.length == 0) return {list: 0}
      let expectedPlugins = 0;
      let eventsCount = 0;
      let totalUtilization = 0;
      data.forEach((item:any, idx: number) => {
        if(!idx) expectedPlugins = item.plugins || 1;
        eventsCount += item.count || 0;
      });
      if(eventsCount > expectedPlugins) totalUtilization = 100;
      else totalUtilization = (eventsCount / expectedPlugins) * 100;

			return {list: totalUtilization} 

		};
	}

  eventEmit(event: {type: string, data: any}) {

		switch (event.type) {
			case "filteredData":
				this.filteredData = event.data;
				break;
			case 'export':
				this.handleExport(event.data);
				break;
		}
	}


  private handleExport(eventData: any) {
      //Flatten the filtered data into a single array
      const currentData = this.filteredData;
  
      let exportFilters = this.commonUtil.getExportWidgetFiltersInfo(eventData);
      let csvData: any = [
        { a: `Site: ${this.customerName}/${this.siteName}` }
      ];
  
      //Add filters info
      for(let key in exportFilters) {
        csvData.push({a: exportFilters[key]});
      }
  
      // Add metadata
      csvData.push(
        {a: `Date of print: ${moment().format('LL')}`},
      );
  
      // Add headers
      csvData.push({
        a: "PolarLink ID",
        b: "PolarLink SN",
        c: "Utilization %",
      });
  
      // If no data is found, add a default row with zeros
      if (!currentData || currentData.length === 0) {
        csvData.push({
          a: "No Data",
          b: "N/A",
          c: "0.00",
        });
      } else {
        // Process each device from the flattened filtered data
        currentData.forEach((device: any) => {
          csvData.push({
            a: device.id || 'Unknown',
            b: device.serialNumber || 'N/A',
            c: device.count || 'N/A'
          });
        });
      }
  
      let fileName = `PolarLink_Utilization_${this.customerName}_${this.siteName}_${moment().format('YYYY-MM-DD')}`;
      new ngxCsv(csvData, fileName);
    }

}
